import request from '@/utils/request';

// 查询版本列表
export function listVersion(query) {
  return request({
    url: '/ep2/version/list',
    method: 'get',
    params: query,
  });
}

// 查询版本详细
export function getVersion(id) {
  return request({
    url: `/ep2/version/${id}`,
    method: 'get',
  });
}

// 新增版本
export function addVersion(data) {
  return request({
    url: '/ep2/version',
    method: 'post',
    data,
  });
}

// 修改版本
export function updateVersion(data) {
  return request({
    url: '/ep2/version',
    method: 'put',
    data,
  });
}

// 删除版本
export function delVersion(id) {
  return request({
    url: `/ep2/version/${id}`,
    method: 'delete',
  });
}
